import clsx from 'clsx'
import { Link } from './link'

interface TextProps extends React.ComponentPropsWithoutRef<'p'> {
  size?: 'sm' | 'base' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl' | '6xl'
  color?: string
}

const textSizes = {
  sm: 'text-sm/4 sm:text-xs/4',
  base: 'text-base/6 sm:text-sm/6',
  lg: 'text-lg/6 sm:text-base/6',
  xl: 'text-xl/6 sm:text-lg/6',
  '2xl': 'text-2xl/6 sm:text-xl/6',
  '3xl': 'text-3xl/6 sm:text-2xl/6',
  '4xl': 'text-4xl/6 sm:text-3xl/6',
  '5xl': 'text-5xl/6 sm:text-4xl/6',
  '6xl': 'text-6xl/6 sm:text-5xl/6',
}

export function Text({ className, size = 'base', color, ...props }: TextProps) {
  return (
    <p
      data-slot="text"
      { ...props }
      className={ clsx(className, textSizes[size], color || 'text-zinc-500 dark:text-zinc-400') }
    />
  )
}

export function TextLink({ className, ...props }: React.ComponentPropsWithoutRef<typeof Link>) {
  return (
    <Link
      { ...props }
      className={ clsx(
        className,
        'text-zinc-950 underline decoration-zinc-950/50 data-hover:decoration-zinc-950 dark:text-white dark:decoration-white/50 dark:data-hover:decoration-white'
      ) }
    />
  )
}

export function Strong({ className, ...props }: React.ComponentPropsWithoutRef<'strong'>) {
  return <strong { ...props } className={ clsx(className, 'font-medium text-zinc-950 dark:text-white') } />
}

export function Code({ className, ...props }: React.ComponentPropsWithoutRef<'code'>) {
  return (
    <code
      { ...props }
      className={ clsx(
        className,
        'rounded-sm border border-zinc-950/10 bg-zinc-950/2.5 px-0.5 text-sm font-medium text-zinc-950 sm:text-[0.8125rem] dark:border-white/20 dark:bg-white/5 dark:text-white'
      ) }
    />
  )
}
